let isSwitchPending = false;

export const beginDealViewSwitch = (): void => {
  isSwitchPending = true;
};

export const isDealViewSwitchPending = (): boolean => isSwitchPending;

export const endDealViewSwitch = (): void => {
  isSwitchPending = false;
};
